import * as user from '@common/store/modules/user/types';

const getters = {
  [user.USERS]: state => state.users,
  [user.OWNERS]: state => state.owners,
  [user.USERS_ISLOADING]: state => state.users.isLoading,
  [user.USERS_COUNT]: state => state.users.totalElements,
  [user.USER]: state => state.user,
  [user.USER_MAIN]: state => state.main,
  [user.OWNER]: state => state.owner,
  [user.USER_AUTH_AREA]: state => state.authArea,
  [user.USER_STATUS]: state => state.userStatus,
};

export default getters;
